/**
 * Button
 */

import React from 'react';
import { ButtonProps } from '../types';
import UIButton from 'components/Button';

const Button: React.FC<ButtonProps> = ({
	type = 'button',
	onFieldChange,
	resetForm,
	showError,
	visibleFields,
	children,
	...propsToTransfer
}) => {
	if (type === 'reset') {
		return (
			(
				<UIButton htmlType="reset" displayWidth="full" onClick={resetForm} {...propsToTransfer}>
					{children}
				</UIButton>
			)
		);
	} else {
		return (
		<UIButton htmlType={type} displayWidth="full" {...propsToTransfer}>
			{children}
		</UIButton>
		);
	}
};

export default Button;
